import { X } from "@phosphor-icons/react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import { typedObjectEntries } from "common/helpers/utils";

import { ACCOUNTS_FILTERS } from "../../constants";
import AccountFilterOptions from "../AccountFilterOptions";

import type { AccountSearchParams } from "../../types";

export default function DesktopFilterTags({
  searchParams,
  setSearchParams,
}: {
  searchParams: AccountSearchParams;
  setSearchParams: (searchParams: AccountSearchParams) => void;
}) {
  return (
    <div className="gap-1.5 flex">
      {typedObjectEntries(searchParams).map(
        <SearchParamsKey extends keyof AccountSearchParams>([
          key,
          selectedFilters,
        ]: [SearchParamsKey, AccountSearchParams[SearchParamsKey]]) => {
          if (selectedFilters.length) {
            const { icon, label, options } = ACCOUNTS_FILTERS[key];

            return (
              <div
                className="flex border border-black-200 rounded-md h-6"
                key={key}
              >
                <DropdownMenu>
                  <DropdownMenuTrigger className="flex px-2 items-center gap-x-1 text-button-xs hover:bg-black-100 [&>svg]:size-4 [&>svg]:-ml-1">
                    {icon}
                    <span>{label}</span>
                    <span className="text-black-500">
                      {selectedFilters.length > 1 ? "is one of" : "is"}
                    </span>
                    <span>
                      {selectedFilters.length === 1
                        ? options[
                            selectedFilters[0] as AccountSearchParams[SearchParamsKey][number]
                          ]
                        : `${selectedFilters.length} values`}
                    </span>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent className="min-w-[var(--radix-popper-anchor-width)] max-w-52">
                    <DropdownMenuList>
                      <AccountFilterOptions
                        searchParamsKey={key}
                        setSearchParams={setSearchParams}
                        searchParams={searchParams}
                      />
                    </DropdownMenuList>
                  </DropdownMenuContent>
                </DropdownMenu>

                <button
                  type="button"
                  className="px-1 border-l border-l-black-200 hover:bg-black-100"
                  onClick={() =>
                    setSearchParams({ ...searchParams, [key]: [] })
                  }
                >
                  <X />
                </button>
              </div>
            );
          }
        },
      )}
    </div>
  );
}
